import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import React from "react";
import { MenuOptionType } from "../../../../../controls";
import { Setting } from "../../models/Setting";

type Props = {
	setSettingId: Function;
	setShowDeleteModal: Function;
	setShowCreateModal: Function;
	setShowEditModal: Function;
};
export const useSettingsOptionsFunctions = ({
	setSettingId,
	setShowDeleteModal,
	setShowCreateModal,
	setShowEditModal,
}: Props) => {
	const getMenuOptions = (data: Setting) => {
		let options: MenuOptionType[] = [];
		if (!data) {
			options = options.concat([
				{
					name: "New Setting",
					key: "new_setting",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
			]);
		} else {
			options = options.concat([
				{
					name: "New Setting",
					key: "new_setting",
					onClick: () => {
						setShowCreateModal(true);
					},
					icon: <PlaylistAddIcon />,
				},
				{
					name: "Edit Setting",
					key: "edit_setting",
					onClick: () => {
						setSettingId(data);
						setShowEditModal(true);
					},
					icon: <EditIcon />,
				},
				{
					name: "Delete Setting",
					key: "delete_setting",
					onClick: () => {
						setSettingId(data);
						setShowDeleteModal(true);
					},
					icon: <DeleteIcon />,
				},
			]);
		}
		return options;
	};
	return {
		getMenuOptions,
	};
};
